// TAPINTO® Editor Frontend - Breakpoint Selector Component
// Version: 1.0
// Date: 2025-10-01

import React from 'react';
import { Monitor, Tablet, Smartphone } from 'lucide-react';
import { Button } from '../common/Button';
import { Breakpoint } from '../../types';

interface BreakpointSelectorProps {
  value: Breakpoint;
  onChange: (breakpoint: Breakpoint) => void;
}

export function BreakpointSelector({ value, onChange }: BreakpointSelectorProps) {
  const breakpoints = [
    { key: 'mobile' as const, icon: Smartphone, label: 'Mobile', width: '375px' },
    { key: 'tablet' as const, icon: Tablet, label: 'Tablet', width: '768px' },
    { key: 'desktop' as const, icon: Monitor, label: 'Desktop', width: '100%' },
  ];

  return (
    <div className="flex items-center space-x-1 bg-neutral-100 rounded-lg p-1">
      {breakpoints.map(({ key, icon: Icon, label, width }) => (
        <Button
          key={key}
          variant={value === key ? 'primary' : 'ghost'}
          size="sm"
          onClick={() => onChange(key)}
          title={`${label} (${width})`}
          className="px-3"
        >
          <Icon className="h-4 w-4" />
        </Button>
      ))}
    </div>
  );
}
